var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPartnerBg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1449,
    height: 538,
    viewBox: "0 0 1449 538",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1379_7364)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1449,
    height: 538,
    fill: "#120F17"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.56,
    filter: "url(#filter0_f_1379_7364)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 39,
    cy: 75,
    rx: 263,
    ry: 199,
    fill: "#524B87"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1467.37 511.336C1467.47 510.487 1467.55 509.638 1467.55 508.763C1467.55 507.888 1467.47 507.039 1467.37 506.19H1471.72C1471.93 507.013 1472.05 507.875 1472.05 508.763C1472.05 509.65 1471.93 510.512 1471.72 511.336H1467.37ZM1465.09 518.488C1465.87 517.06 1466.46 515.517 1466.87 513.909H1470.67C1469.43 516.031 1467.46 517.678 1465.09 518.488ZM1464.77 511.336H1458.75C1458.62 510.487 1458.55 509.638 1458.55 508.763C1458.55 507.888 1458.62 507.026 1458.75 506.19H1464.77C1464.89 507.026 1464.98 507.888 1464.98 508.763C1464.98 509.638 1464.89 510.487 1464.77 511.336ZM1461.76 519.003C1460.7 517.459 1459.83 515.748 1459.31 513.909H1464.22C1463.69 515.748 1462.83 517.459 1461.76 519.003ZM1456.62 503.617H1452.86C1454.08 501.482 1456.06 499.835 1458.42 499.037C1457.65 500.465 1457.07 502.009 1456.62 503.617ZM1452.86 513.909H1456.62C1457.07 515.517 1457.65 517.06 1458.42 518.488C1456.06 517.678 1454.08 516.031 1452.86 513.909ZM1451.81 511.336C1451.6 510.512 1451.47 509.65 1451.47 508.763C1451.47 507.875 1451.6 507.013 1451.81 506.19H1456.15C1456.05 507.039 1455.97 507.888 1455.97 508.763C1455.97 509.638 1456.05 510.487 1456.15 511.336H1451.81ZM1461.76 498.51C1462.83 500.054 1463.69 501.777 1464.22 503.617H1459.31C1459.83 501.777 1460.7 500.054 1461.76 498.51ZM1470.67 503.617H1466.87C1466.46 502.009 1465.87 500.465 1465.09 499.037C1467.46 499.848 1469.43 501.482 1470.67 503.617ZM1461.76 495.898C1454.65 495.898 1448.9 501.687 1448.9 508.763C1448.9 512.175 1450.25 515.447 1452.67 517.859C1453.86 519.054 1455.28 520.002 1456.84 520.648C1458.4 521.295 1460.07 521.627 1461.76 521.627C1465.17 521.627 1468.45 520.272 1470.86 517.859C1473.27 515.447 1474.63 512.175 1474.63 508.763C1474.63 507.073 1474.29 505.401 1473.65 503.84C1473 502.279 1472.05 500.861 1470.86 499.666C1469.66 498.472 1468.25 497.524 1466.69 496.878C1465.13 496.231 1463.45 495.898 1461.76 495.898Z",
    fill: "url(#paint0_linear_1379_7364)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1467.37 511.336C1467.47 510.487 1467.55 509.638 1467.55 508.763C1467.55 507.888 1467.47 507.039 1467.37 506.19H1471.72C1471.93 507.013 1472.05 507.875 1472.05 508.763C1472.05 509.65 1471.93 510.512 1471.72 511.336H1467.37ZM1465.09 518.488C1465.87 517.06 1466.46 515.517 1466.87 513.909H1470.67C1469.43 516.031 1467.46 517.678 1465.09 518.488ZM1464.77 511.336H1458.75C1458.62 510.487 1458.55 509.638 1458.55 508.763C1458.55 507.888 1458.62 507.026 1458.75 506.19H1464.77C1464.89 507.026 1464.98 507.888 1464.98 508.763C1464.98 509.638 1464.89 510.487 1464.77 511.336ZM1461.76 519.003C1460.7 517.459 1459.83 515.748 1459.31 513.909H1464.22C1463.69 515.748 1462.83 517.459 1461.76 519.003ZM1456.62 503.617H1452.86C1454.08 501.482 1456.06 499.835 1458.42 499.037C1457.65 500.465 1457.07 502.009 1456.62 503.617ZM1452.86 513.909H1456.62C1457.07 515.517 1457.65 517.06 1458.42 518.488C1456.06 517.678 1454.08 516.031 1452.86 513.909ZM1451.81 511.336C1451.6 510.512 1451.47 509.65 1451.47 508.763C1451.47 507.875 1451.6 507.013 1451.81 506.19H1456.15C1456.05 507.039 1455.97 507.888 1455.97 508.763C1455.97 509.638 1456.05 510.487 1456.15 511.336H1451.81ZM1461.76 498.51C1462.83 500.054 1463.69 501.777 1464.22 503.617H1459.31C1459.83 501.777 1460.7 500.054 1461.76 498.51ZM1470.67 503.617H1466.87C1466.46 502.009 1465.87 500.465 1465.09 499.037C1467.46 499.848 1469.43 501.482 1470.67 503.617ZM1461.76 495.898C1454.65 495.898 1448.9 501.687 1448.9 508.763C1448.9 512.175 1450.25 515.447 1452.67 517.859C1453.86 519.054 1455.28 520.002 1456.84 520.648C1458.4 521.295 1460.07 521.627 1461.76 521.627C1465.17 521.627 1468.45 520.272 1470.86 517.859C1473.27 515.447 1474.63 512.175 1474.63 508.763C1474.63 507.073 1474.29 505.401 1473.65 503.84C1473 502.279 1472.05 500.861 1470.86 499.666C1469.66 498.472 1468.25 497.524 1466.69 496.878C1465.13 496.231 1463.45 495.898 1461.76 495.898Z",
    fill: "#BCBCBC"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 315.5,
    y1: -2.18557e-8,
    x2: 315.5,
    y2: 600,
    stroke: "#4D4563",
    strokeOpacity: 0.6,
    strokeDasharray: "10 10"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 495.5,
    y1: -2.18557e-8,
    x2: 495.5,
    y2: 600,
    stroke: "#4D4563",
    strokeOpacity: 0.6,
    strokeDasharray: "10 10"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1025.5,
    y1: -2.18557e-8,
    x2: 1025.5,
    y2: 355,
    stroke: "#4D4563",
    strokeOpacity: 0.6,
    strokeDasharray: "10 10"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -4.37114e-8,
    y1: 192.5,
    x2: 1257,
    y2: 192.5,
    stroke: "#4D4563",
    strokeDasharray: "10 10"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -4.37114e-8,
    y1: 350.5,
    x2: 1029,
    y2: 350.5,
    stroke: "#6F6882",
    strokeDasharray: "10 10"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 697.652,
    y: 450.091,
    width: 206.068,
    height: 86.6079,
    fill: "url(#paint1_linear_1379_7364)",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M578 537.28L697.652 450.092L697.652 537.28L578 537.28Z",
    fill: "url(#paint2_linear_1379_7364)",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1256.89,
    y: 192.35,
    width: 192.11,
    height: 279.677,
    fill: "url(#paint3_linear_1379_7364)",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1254.59 472.027H1447.93V537.05H1152.3L1254.59 472.027Z",
    fill: "url(#paint4_linear_1379_7364)",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M901.211 449.864L1257.68 192.502L1257.68 472.962L1152.02 537.202L901.211 537.202L901.211 449.864Z",
    fill: "url(#paint5_linear_1379_7364)",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_1379_7364)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1025,
    cy: 194,
    r: 4,
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_1379_7364)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1025,
    cy: 352,
    r: 4,
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_1379_7364",
    x: -693.419,
    y: -593.419,
    width: 1464.84,
    height: 1336.84,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 234.709,
    result: "effect1_foregroundBlur_1379_7364"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_1379_7364",
    x: 997,
    y: 166,
    width: 56,
    height: 56,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 14,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_1379_7364"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1379_7364"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1379_7364",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_1379_7364",
    x: 997,
    y: 324,
    width: 56,
    height: 56,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 14,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_1379_7364"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1379_7364"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1379_7364",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1379_7364",
    x1: 1474.63,
    y1: 521.627,
    x2: 1445.82,
    y2: 516.486,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.07
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.479167,
    stopColor: "white",
    stopOpacity: 0.04
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1379_7364",
    x1: 800.686,
    y1: 450.091,
    x2: 800.686,
    y2: 536.699,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A10193"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.998781,
    stopColor: "#7B06C5",
    stopOpacity: 0.645833
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6405C4",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1379_7364",
    x1: 578,
    y1: 493.686,
    x2: 697.652,
    y2: 493.686,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6405C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.661458,
    stopColor: "#7B06C5",
    stopOpacity: 0.9075
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DD09C8",
    stopOpacity: 0.52
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1379_7364",
    x1: 1352.95,
    y1: 192.35,
    x2: 1352.95,
    y2: 472.027,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6706C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.895833,
    stopColor: "#9D02AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A10193"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1379_7364",
    x1: 1447.93,
    y1: 537.05,
    x2: 1191.25,
    y2: 537.05,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6806C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.526042,
    stopColor: "#6C06C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#960089"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1379_7364",
    x1: 905.755,
    y1: 521.773,
    x2: 1163.09,
    y2: 240.328,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.015625,
    stopColor: "#670F9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.166667,
    stopColor: "#6F0E9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.652646,
    stopColor: "#8A09A2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A20193"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1379_7364"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1449,
    height: 538,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPartnerBg);
export default __webpack_public_path__ + "static/media/partner-bg.13942761f26853e98def3b0ac1d3b9e1.svg";
export { ForwardRef as ReactComponent };